/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * This signifies what the number in the 'amount' field is.
 * @export
 */
export const AmountUnit = {
    FIAT: 'FIAT',
    VARIABLE: 'VARIABLE',
    FIXED: 'FIXED'
} as const;
export type AmountUnit = typeof AmountUnit[keyof typeof AmountUnit];


export function instanceOfAmountUnit(value: any): boolean {
    for (const key in AmountUnit) {
        if (Object.prototype.hasOwnProperty.call(AmountUnit, key)) {
            if (AmountUnit[key as keyof typeof AmountUnit] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AmountUnitFromJSON(json: any): AmountUnit {
    return AmountUnitFromJSONTyped(json, false);
}

export function AmountUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): AmountUnit {
    return json as AmountUnit;
}

export function AmountUnitToJSON(value?: AmountUnit | null): any {
    return value as any;
}

export function AmountUnitToJSONTyped(value: any, ignoreDiscriminator: boolean): AmountUnit {
    return value as AmountUnit;
}

